// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { Tabs as HeroTabs } from "@heroui/react";
import { clsx } from "clsx";
import type { ComponentProps } from "react";

export type TabsProps = ComponentProps<typeof HeroTabs.Root>;

function TabsRoot({
  className,
  variant = "secondary",
  ...props
}: TabsProps) {
  return (
    <HeroTabs.Root
      className={clsx("tapp-tabs", className)}
      variant={variant}
      {...props}
    />
  );
}

export const Tabs = Object.assign(TabsRoot, {
  Root: TabsRoot,
  ListContainer: HeroTabs.ListContainer,
  List: HeroTabs.List,
  Tab: HeroTabs.Tab,
  Indicator: HeroTabs.Indicator,
  Separator: HeroTabs.Separator,
  Panel: HeroTabs.Panel,
});

export type TabsListProps = ComponentProps<typeof HeroTabs.List>;
export type TabProps = ComponentProps<typeof HeroTabs.Tab>;
export type TabPanelProps = ComponentProps<typeof HeroTabs.Panel>;
